// Flow Molar units with conversion factors to mole per second (mol/s)
export const flowMolarUnits = [
  { id: 'mole-per-second', name: 'Mole per Second', symbol: 'mol/s', plural: 'Moles per Second', toBase: 1 },
  { id: 'mole-per-minute', name: 'Mole per Minute', symbol: 'mol/min', plural: 'Moles per Minute', toBase: 1/60 },
  { id: 'mole-per-hour', name: 'Mole per Hour', symbol: 'mol/h', plural: 'Moles per Hour', toBase: 1/3600 },
  { id: 'mole-per-day', name: 'Mole per Day', symbol: 'mol/d', plural: 'Moles per Day', toBase: 1/86400 },
  { id: 'kilomole-per-second', name: 'Kilomole per Second', symbol: 'kmol/s', plural: 'Kilomoles per Second', toBase: 1000 },
  { id: 'kilomole-per-minute', name: 'Kilomole per Minute', symbol: 'kmol/min', plural: 'Kilomoles per Minute', toBase: 1000/60 },
  { id: 'kilomole-per-hour', name: 'Kilomole per Hour', symbol: 'kmol/h', plural: 'Kilomoles per Hour', toBase: 1000/3600 },
  { id: 'millimole-per-second', name: 'Millimole per Second', symbol: 'mmol/s', plural: 'Millimoles per Second', toBase: 0.001 },
  { id: 'millimole-per-minute', name: 'Millimole per Minute', symbol: 'mmol/min', plural: 'Millimoles per Minute', toBase: 0.001/60 },
  { id: 'pound-mole-per-second', name: 'Pound-mole per Second', symbol: 'lbmol/s', plural: 'Pound-moles per Second', toBase: 453.59237 },
  { id: 'pound-mole-per-hour', name: 'Pound-mole per Hour', symbol: 'lbmol/h', plural: 'Pound-moles per Hour', toBase: 453.59237/3600 },
];

export const popularFlowMolarConversions = [
  { from: 'mole-per-second', to: 'mole-per-minute' },
  { from: 'mole-per-minute', to: 'mole-per-second' },
  { from: 'mole-per-hour', to: 'mole-per-minute' },
  { from: 'mole-per-minute', to: 'mole-per-hour' },
  { from: 'kilomole-per-hour', to: 'mole-per-hour' },
  { from: 'mole-per-hour', to: 'kilomole-per-hour' },
  { from: 'mole-per-second', to: 'mole-per-hour' },
  { from: 'mole-per-hour', to: 'mole-per-second' },
  { from: 'millimole-per-second', to: 'mole-per-second' },
  { from: 'mole-per-second', to: 'millimole-per-second' },
  { from: 'kilomole-per-second', to: 'mole-per-second' },
  { from: 'mole-per-second', to: 'kilomole-per-second' },
  { from: 'pound-mole-per-hour', to: 'mole-per-hour' },
  { from: 'mole-per-hour', to: 'pound-mole-per-hour' },
  { from: 'mole-per-day', to: 'mole-per-hour' },
  { from: 'mole-per-hour', to: 'mole-per-day' },
  { from: 'kilomole-per-minute', to: 'mole-per-minute' },
  { from: 'mole-per-minute', to: 'kilomole-per-minute' },
  { from: 'millimole-per-minute', to: 'mole-per-minute' },
  { from: 'mole-per-minute', to: 'millimole-per-minute' },
  { from: 'pound-mole-per-second', to: 'mole-per-second' },
  { from: 'mole-per-second', to: 'pound-mole-per-second' },
];

export const getUnitById = (id) => flowMolarUnits.find(unit => unit.id === id);

export const convertFlowMolar = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert molar flow rate units and learn the conversion formula.`;
};
